// Shared field-format validators.
//
// Both are format-only checks meant to be applied when a value is PRESENT. Phone and email are optional
// on a location (the backend readiness check treats them that way), so callers should skip validation
// for an empty value rather than making these reject it.

// Pragmatic email check. Real validation is sending a message, so this deliberately only catches obvious
// mistakes (missing @, missing domain/TLD, whitespace) instead of attempting RFC 5322.
export const isValidEmail = (value: string): boolean =>
    /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim());

// Phone accepts EITHER:
//   - an international number in E.164: a leading '+', country code, up to 15 digits total, or
//   - a bare US number: 10 digits with an optional leading 1 — so US users are not forced to type +1.
// Common separators (spaces, parens, dashes, dots) are tolerated and ignored.
export const isValidPhone = (value: string): boolean => {
    const compact = value.trim().replace(/[\s().\-]/g, '');
    if (compact.startsWith('+')) return /^\+[1-9]\d{7,14}$/.test(compact);
    return /^1?\d{10}$/.test(compact);
};
